import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/ApiProvider.js';

/**
 * Shared read of a classroom's settings. Uses the exact query key
 * `['classroom-settings', id]` that the Home page and settings panels
 * already read/invalidate, so Home, LiveSurface, and the settings UI all
 * share one cache entry — a settings save (e.g. flipping the grade range)
 * updates every consumer without a reload.
 */
export function useClassroomSettings(classroomId: string | null | undefined) {
  const api = useApi();
  return useQuery({
    queryKey: ['classroom-settings', classroomId ?? 'none'],
    queryFn: () => api.home.getSettings(classroomId as string),
    enabled: !!classroomId,
  });
}
